/**
 * Sesión JWT del admin legacy C# (admin1.estudyoo.cl).
 * Distinta de la sesión Django staff.
 */

export function isLegacyCSharpApiUrl(url) {
  const u = String(url || '');
  if (!u || u.includes('/auth/google')) return false;
  const api = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '');
  if (api && u.startsWith(api)) return true;
  return u.includes('admin1.estudyoo.cl/backend/api');
}

export function hasLegacyAccessToken(store) {
  return !!store?.getters?.['auth/accessToken'];
}

export function clearLegacySession(store) {
  store?.commit?.('auth/setAccessToken', null);
}
